<div class="rfq-tab" id="rfq-tab" *ngIf="tabLoaded; else loading">
  <div class="rfq-tab__leg-control-panel" *ngIf="!tabData.static">
    <clr-dropdown>
      <button
        *ngIf="!isRunning"
        class="ui-button ui-button__header primary rfq-tab__leg-control-panel__add-leg simple-tooltip"
        type="button"
        clrDropdownTrigger
        data-tooltip="Add leg"
      >
        <cds-icon shape="plus" class="is-solid"></cds-icon>
      </button>
      <clr-dropdown-menu class="level1" clrPosition="top" *clrIfOpen>
        <clr-dropdown *ngFor="let productGroup of productGroupings">
          <button clrDropdownTrigger>{{ productGroup.longName }}</button>
          <clr-dropdown-menu>
            <clr-dropdown *ngFor="let productItem of productGroup.items">
              <ng-container
                *ngIf="productItem.currencyPair; else noCurrencyPair"
              >
                <button
                  clrDropdownTrigger
                  (click)="focusCrossDropdown(productItem.shortName)"
                  (keydown.ArrowRight)="
                    focusCrossDropdown(productItem.shortName)
                  "
                  (keydown.enter)="focusCrossDropdown(productItem.shortName)"
                >
                  {{ productItem.name }}
                </button>
                <clr-dropdown-menu
                  class="scrollable-content {{ productItem.shortName }}-menu"
                >
                  <clr-combobox-container>
                    <clr-combobox
                      [(ngModel)]="crossFilter"
                      (keydown.enter)="crossKeydown()"
                      placeholder="Select a currency pair"
                      class="cross-combobox {{ productItem.shortName }}"
                      #comboBox
                      (input)="menuCrossInputChange(comboBox)"
                    >
                      <clr-options class="rfq-cross-options scrollable-content">
                        <!-- for some reason, click events here are ignored so the (hacky)
                        workaround is via mouseup -->
                        <clr-option
                          *clrOptionItems="
                            let cross of productItem.currencyPair
                          "
                          (mouseup)="
                            addProduct(productItem.name, true, {
                              cross: cross
                            })
                          "
                          clrValue="{{ productItem.name }}|{{ cross }}"
                        >
                          {{ cross }}
                        </clr-option>
                      </clr-options>
                    </clr-combobox>
                  </clr-combobox-container>
                </clr-dropdown-menu>
              </ng-container>

              <ng-template #noCurrencyPair>
                <button
                  (click)="addProduct(productItem.name, true)"
                  clrDropdownItem
                >
                  {{ productItem.name }}
                </button>
              </ng-template>
            </clr-dropdown>
          </clr-dropdown-menu>
        </clr-dropdown>
      </clr-dropdown-menu>
    </clr-dropdown>
  </div>
  <div class="rfq-tab__controller scrollable-content scrollable-content-x">
    <div
      class="rfq-tab__controller__collapse"
      (click)="showHideLegs()"
      *ngIf="legs?.length > 3"
    >
      <span
        class="rfq-tab__controller__collapse__arrow"
        [ngClass]="{
          'rfq-tab__controller__collapse__arrow--closed': !showLegs
        }"
      >
        &lt;
      </span>
    </div>
    <div
      class="rfq-tab__controller__legs-container"
      *ngIf="legs?.length"
      [@openClose]="showLegs ? 'open' : 'closed'"
    >
      <div
        class="rfq-tab__controller__legs-container__attributes"
        [ngClass]="{
          'rfq-tab__controller__legs-container__attributes--not-static':
            !rfqExecutionSettings.static
        }"
        id="legAttribute"
      >
        <active-attributes
          [rfqExecution]="true"
          [genericMultiHedge]="isGenericMultiHedge"
          [legs]="legs"
        ></active-attributes>
      </div>
      <div
        class="rfq-tab__controller__legs-container__legs scrollable-content"
        cdkDropList
        [cdkDropListData]="legs"
        [cdkDropListOrientation]="'horizontal'"
        (cdkDropListDropped)="drop($event)"
      >
        <app-leg
          *ngFor="let leg of legs; index as i"
          [legIndex]="i"
          [leg]="leg"
          [rfqExecutionSettings]="rfqExecutionSettings"
          [legSyncingInfo]="legSyncingInfo"
          [cdkDragLockAxis]="'x'"
          [fieldsToBeEdited]="
            tabData.legs[i]?.fieldsToBeEdited || defaultFieldsToBeEdited
          "
          (changeInLeg)="updateOnLegChange()"
          (fieldBlurred)="updateOnLegChange(true)"
          (dropdownChange)="updateOnLegChange(true)"
          (keyup.enter)="blurCurrentElement(i)"
          (legPresetLoaded)="onLegPresetLoaded(i)"
          cdkDrag
          [cdkDragDisabled]="rfqExecutionSettings.isPricing"
          [formInert]="rfqTabService.legFormsInert()"
          [parentTabIndex]="parentTabIndex"
        >
          <div cdkDragHandle class="btn-dragarea"></div>
        </app-leg>
      </div>
    </div>
    <div class="rfq-tab__controller__setup">
      <app-rfq-setup
        [blockVolBasedPriceHedgeChanges]="blockVolBasedPriceHedgeChanges"
        [legSyncingInfo]="legSyncingInfo"
        [rfqTab]="tabData"
        [pipsHighlightedIndices]="pipsHighlightedIndices"
        (hedgeChange)="onHedgePremiumChange($event, 'hedge')"
        (premiumChange)="onHedgePremiumChange($event, 'premium')"
        (providersChange)="onProvidersChange($event)"
        (numOfProvidersAvailable)="numOfProvidersAvailable($event)"
        (premiumStyleChange)="premiumStyleChange()"
        (premiumValueChange)="premiumValueChange($event)"
        [showBookTrades]="rfqPricesComponent?.showBookTrades"
        [bookingState]="bookingState"
      ></app-rfq-setup>
    </div>
  </div>
  <div class="rfq-tab__prices">
    <app-rfq-prices
      (pricerToMainTabCommunicator)="pricerToMainTabCommunicator($event)"
      (removeIndicativePrices)="removeIndicativePrices()"
      [indicativePremiumStyle]="indicativePremiumStyle$ | async"
      [rfqPricingMessages]="rfqPricingMessages"
      [parentTabComponent]="this"
      [bookTradesCmpt]="bookTradesCmpt()"
      [forwardPointsMultiplier]="forwardPointsMultiplier"
      [pipsHighlightedIndices]="pipsHighlightedIndices"
      [rfqTabData]="tabData"
      [bookingState]="bookingState"
      [nonDxExists]="nonDxExists"
    ></app-rfq-prices>
  </div>
  @if (rfqPricesComponent?.showBookTrades) {
    <app-rfq-book-trades
      [parentPricesComponent]="rfqPricesComponent"
      [nonDxExists]="nonDxExists"
      [volBased]="rfqPricesComponent?.volBased"
      (resetRfqContainerHeight)="resetRfqContainerHeightFunc()"
      (stateChange)="onBookingStateChange($event)"
    >
    </app-rfq-book-trades>
  }
</div>

<ng-template #loading>
  <div
    class="spinner-container"
    *ngIf="!failedExecutionContext; else getExecutionContextFailed"
  >
    <span class="spinner spinner-md spinner-inverse"> </span>
  </div>

  <ng-template #getExecutionContextFailed>
    <div class="execution-context-failed">
      Failed to get the execution context
    </div>
  </ng-template>
</ng-template>
